const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

//convert url to file
export const convertUrlToFile = async (url: string) => {
    const response = await fetch(`${storageURL}/${url}`);
    const blob = await response.blob();
    const ext = url.split('.').pop() || 'png';
    const fileName = url.split('/').pop()?.split('.').slice(0, -1).join('') || 'file';
    return new File([blob], `${fileName}.${ext}`, { type: blob.type });
};